import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface App {
  id: string
  package_name: string
  name?: string
}

interface PackageStore {
  selectedApp: App | null
  appList: App[]
  appListLoaded: boolean
  setSelectedApp: (app: App | null) => void
  setAppList: (apps: App[]) => void
  clearSelectedApp: () => void
}

export const usePackageStore = create<PackageStore>()(
  persist(
    (set) => ({
      selectedApp: null,
      appList: [],
      appListLoaded: false,
      setSelectedApp: (app) => set({ selectedApp: app }),
      setAppList: (apps) =>
        set((state) => ({
          appList: apps,
          appListLoaded: true,
          selectedApp: apps.find((app) => app.id === state.selectedApp?.id) ?? apps[0] ?? null,
        })),
      clearSelectedApp: () => set({ selectedApp: null }),
    }),
    {
      name: 'echat-admin-selected-app',
      partialize: (state) => ({ selectedApp: state.selectedApp }),
    }
  )
)

// Alias for backward compatibility
export const useAppStore = usePackageStore
